export interface UserLoginHistory {
  userId: number;
  lastLoginTime: number;
}
